import { render, staticRenderFns } from "./TabOVSolicitudData.vue?vue&type=template&id=81d03e8c&scoped=true&lang=pug"
import script from "./TabOVSolicitudData.vue?vue&type=script&lang=js"
export * from "./TabOVSolicitudData.vue?vue&type=script&lang=js"
import style0 from "./TabOVSolicitudData.vue?vue&type=style&index=0&id=81d03e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d03e8c",
  null
  
)

export default component.exports